<template>
  <div class="g-footer-wrap">
    <div class="m-layout-center">
      <div class="m-foot-content">
        <div class="fl foot-l">
          <div class="fl">
            <router-link to="/">
              <img
                class="u-logo"
                src="data:image/png;base64,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"
                alt=""
              />
            </router-link>
          </div>
          <div class="fl">
            <ul class="mb30">
              <li>
                <dl>
                  <dt><router-link to="/solution">解决方案</router-link></dt>
                </dl>
              </li>
              <li>
                <dl>
                  <dt><router-link to="/news">新闻中心</router-link></dt>
                </dl>
              </li>
              <li>
                <dl>
                  <dt><router-link to="/about">关于我们</router-link></dt>
                </dl>
              </li>

              <li>
                <dl>
                  <dt><router-link to="/about/platform">联系我们</router-link></dt>
                </dl>
              </li>
            </ul>
          </div>
        </div>
        <div class="fr m-foot-main foot-r">
          <div class="m-foot-bottom">
            <div class="m-contact-info">
              <p class="m-email-box">
                <img
                  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEsAAABLCAYAAAA4TnrqAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAS6ADAAQAAAABAAAASwAAAACnw0WBAAAEm0lEQVR4Ae2aj1XbMBDGm07gEdIJ6m6QEdwNxARlA7QB6QRxJ6AbwAaEDdgAdwL6faltzodQFNlJnL679+5Zf+8+/SIrjuHTJzMjYASMgBEwAkbACBgBI2AEjIARMAJGwAgYASNgBIyAEcgg8Pr6WsI38EuzRwh2GUveTfmcM3GxWGwxb5Ez98xzviA/tWdZFixmAjCHy0+WL8SeoHPVftDHlYztuwptYbbB525bCCwkIdSX8GvZNlkZgWs4baODoq2CN+ycoVG3BsUz96XVutTrGV0XwZljAw8JmBuwWi8cuvnBdqBQzD/wdey+zqjK+M2igXFrb9W4c1VdL74tQIgLiPF63Oh6IAmbCKyUwVEv4OcE1iC/k5pYRtstPGRejx1dD2Vp27ilB8CYDG11ZM6xuggqpGUTSehHw9EBIsnYRWAuMGe9Z96U3dzNA1CoF3Du/ph5rXt0PZZN9DmdCH2hc0JMmaRIUIXMjfoSvg8Uk3s5b5IyoybaqR8teLtrUCXauNtT7KywKHADDy2gYeeEVuudgNgVPBUUpZwdFkXwFtDAeGvwlpnCXABUzi0/C1gEQmClXBTqBXwMsAbzQ6Bu0Z5js4FF8bwlBsAID208aw41ggrF2hwaSIyfFSzqIjBHSNLQtmZnonE3DkChXsC5e8eYl5omKY9RI+Y6LQZ9KecMQRVyLupL+FhQCJF+wGe/z5LCDyiv9Fi8X6rR9h3+R/e19V+48j1Uo/oJjy/z5mf8CEba79iqELuENypHvWdOpcbnVH0sR1ZfjgoxJ3Qb3aA/dGtxLM1poWyDl7K9bcMl27yMN0k5W8q/xwQN5bqNxzNHL75AW6VFo+1WzNHxfNuXc5kNrAbqNQx9oL/oMQFQG0WBkDWwWo1Jrc4CVghU9cEKCMwFIHGXEUzI7gLjc4DNAtZKLgarLeGEEjPXzcGgJfwjUF2MwY92NBLututMvPou52TXxMTdMCcTozEFVDf3DoUb+D6w3Xivch0KbDBfxsoud8oSrtcyCcZT/L4dkhA2OsSpnNyVTXTGW6eXcycpv8WOlmqZDCNPAaoT5FTuEh0pwLycN0m5UxS51joRxvKWOpXxttXfvAS2z7zW/VF9qp87T+2f8/s8UMjDt+objl/go8Q98vbA2j/VX02VegpYu/8hkIIgeI26k20nKhMYdzOvO2t/e04GrIsbvUJAyHgm9MIYAHUXGnjiNn6haF31Bxp8dOGic8zO4luCwdsAiHFoGzz7iFynLJZINnhobY8JvsE4vgU+FQrqDf08THnIzsnefXAQ96AE+n4Rewq5O+uqPTx34ZGc4O7hg62/J/cpunkkaGAVEvOcPZ4haffM4mQWtBfwue0oSBpYSPNzO4LwpjUEXtNlVNQJiofpJZhT2kuIJrDku2EhA8TKDIpbr5Fj0PaIeinbZl7+po6Pd2uK6U8+swKgeBZcEihyuMcH3GvWa4qBYl/yzpKBkHCN+g/ZdkHlBlq5w54P1ZwLq0AiB6/gLH+Fz9n4TLiFP8NrgHrA1cwIGAEjYASMgBEwAkbACBgBI2AEjIARMAJGwAj81wT+AsPd25ZRbvntAAAAAElFTkSuQmCC"
                  alt=""
                  style="width: 37.5px; height: 37.5px;margin-right:10px"
                />
                ymt@ymtcloud.com
              </p>
              <p class="m-phone-box">
                <img
                  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEsAAABLCAYAAAA4TnrqAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAS6ADAAQAAAABAAAASwAAAACnw0WBAAAEgklEQVR4Ae2Z7XHbOBCG7cz9P5bAEtjBsQR2cEoFcQdWKrA6EK+CuAPrKrBSgdKBlQqc59VwMzBESgRFizCDnVkvsLvYj5cARMk3N4kSAgmBhEBCICGQEEgIJAQSAgmBhEBCIBYEXl9fc/gfOIulpijrAKAFbPTCoIyy0KmLApjKUPJkNXVtUeUHnALWTvJpj0LHMgGmJwYQp4CSbQ2L7qN6wtcuBgD6AnVAiz+ra9cYRT4az+BnQ8GTFfO1p7NpEUUD1yqCrk8BpU9E91PRQDL5dK06o8hD1yvr3JPngDL3bOxGPo0dcMR4bUfpaxN/3SNP1cMnyCVmsGqvk/+YP8IPnr5rmncZZqnnPC2bM1UjC7jtPatxORLLWYJyqikgKOFQoITc4lTcIbaYj+Ghn9vb2w2DEg69sLesGZWiB6vpNrTxn4AcuuYssB8FrLONeA6P3nyU6UcBqwzsdhnoPx93LuudbuyetJlP54GdAJDe2EMoD0wxD3cQ0vfDXQBSy3l0PqALQOr6ftiG3+iffgNKnmYJaOhlNISKaSqdOCsI5XDIV5vFxCVPkx6QdE91/eCH6YjqaSqNICtQfDuCo1uxxZRFUPb1S6DxdTcuR5Y9mvz6VUaQkcbXR3CcVvyxF3ooUIsInu9lJbARdDl/gf/tE6nxD7mjWDL+71R9ah3VhyYK+EXdNPSM7Lx8scl/B4dQPWrRUwSj2673oo1fD77affdwKNV+rGvPby9NSMfaPfo/XduF+xm97H/DohyuYOlC6H9+zCtDFkTnK6BgHbc20q8F4ktpS4BQcKPD6oYmElB9HgtAreE2qlGWbYZA3Wx21LqjcQFVwO6nYofrSfVsgBIYbZSA8o8kKLUdscNOwJZ2lAsYgGSwwDHSOIe7LnvzOydrN89sxnRtgCWg+jzVBrAxdtSiT74YfP4aWgRv1HsA0/Kh3wK+s3bxHv9mH9rTu69rdtgG2ZcE8hL++G/lQ9Gl+Qr+AXeRbCs4H5pj6nVDj1Bn3YBRYKwchz3jLcdt4+jSEKBK+EtCogcCAGVU9nA/60IwHe0nSd8Z3QP8Dc5cG/Oi0d+7eo3Rd8bzfd99TjFGd5cmI5B2qdGLGw+l7j6jldlQZPDODMjSsXXGM5+rSorbNoXWlyQmht/0xuJhq5ocJn4/GBRrUzYy1zrGiud+FdtIPylR0LIpUuLN8QgpjLU6XkZ7BoXWIzubxrawBY10QfTj5SH1vIsvReZOwfqpOZhYf6rpJye+QMyVQBJ2d86jJUZ/B7u0MNvkkqrc4p6Zl32LwreA+zZdWVzWKI+RQMxkQyqeS7WtiUZSXe1WyHgHP8EPDWtsDT5b4Y6O4eEF92zT+C3l7FCpeMwz2HLI/EM6yxWVpLCqKRBxkg47AY/S8yqtIfSPjm3L+HfTjl7DlbNG+V0qzBatpFqBsITV8MbhFeM7OFfxkvAeFt25DTHXepHsb5pmvpUB2nprOuO5fh92TMNq8A0Y1oz0stvclehLd25j+WudzZNMCCQEEgIJgYRAQiAhkBCIE4FfH9b9bJheebEAAAAASUVORK5CYII="
                  alt=""
                  style="width: 37.5px; height: 37.5px; margin-right:10px"
                />
                400 8786 999
              </p>
              <p class="fl hover-container">
                <img
                  src="data:image/png;base64,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"
                  alt=""
                  class="wx-icon"
                />
                 <img src="../assets/images/codewx.png" alt="" class="qr-img" />
              </p>
            </div>
            <div class="f12 m-contact-info">
              <p>
                copyright@2018 YMT e-Business Solutions Lnc
                <a style="padding-left:10px; padding-right:10px;"
                  href="http://beian.miit.gov.cn"
                  target="_blank"
                >
                  黔ICP备18009963号-1</a
                >
                公安备案号 52011502000817
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  props: {
    msg: String,
  },
  methods: {
    //   Handleenter () {
    //       console.log(this.$refs.footerimg)
    //      console.log(this.$refs.footerimg.setAttribute("class", "qr-imgshow"))
    //   },
    //   Handleleave() {
    //       console.log(this.$refs.footerimg.setAttribute("class", "qr-img"))
    //   }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.g-footer-wrap {
  width: 100%;
  height: 142px;
  background-color: #111;
}

.hover-container {
  cursor: pointer;
  position: relative;
  width: 50px;
  height: 50px;
  .wx-icon{
    width: 33px; 
    height: 33px;
    float: right;
  }
  .qr-img {
      height: 133px;
      width: 133px;
      position: absolute;
      visibility: hidden;
        top: -133px;
        left: -34px;
        display: inline-block;
    z-index: 999999999;
  }
}
.hover-container:hover {
  cursor: pointer;
  position: relative;
  width: 50px;
  height: 50px;
  .wx-icon{
    width: 33px; 
    height: 33px;
    float: right;
  }
  .qr-img {
      height: 133px;
      width: 133px;
      visibility:visible;
      position: absolute;
        top: -133px;
        left: -34px;
        display: inline-block;
    z-index: 999999999;
  }
}
.m-foot-content {
//   overflow: hidden;
  padding: 30px 0;
  // height: 142px;
  color: #fff;
}
.u-logo {
  width: 40px;
  height: 38px;
}
.m-foot-logo {
  width: 100px;
  margin-right: 200px;
}
ul {
  list-style-type: none;
  padding: 0;
//   overflow: hidden;
}
li {
  font-size: 14px;
  float: left;
  margin: 8px 0 0 40px;
  font-weight: 600;
}
a {
  color: #fff;
  text-decoration: none;
}
dt {
  margin-bottom: 10px;
  // font-weight: 600;
}
dd {
  line-height: 24px;
}

// .m-foot-bottom {
//   overflow: hidden;
// }
.m-contact-info {
  width: 600px;
  // border-bottom: 2px solid #fff;
  p {
    margin-bottom: 10px;
    float: left;
  }
}
.m-email-box {
  // background: url(../assets/images/e_mail@2x.png) no-repeat left center;
  // background-size: 24px 18px;
  -webkit-box-align: center;
  align-items: center;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  margin-right: 108px;
  font-size: 14px;
}
.m-phone-box {
  // background: url(../assets/images/phone@2x.png) no-repeat left center;
  // background-size: 24px 22px;
  -webkit-box-align: center;
  align-items: center;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  margin-right: 108px;
  font-size: 14px;
}
.foot-l{
  margin-top: 20px;
}
.foot-r{
  width: 580px;
  margin-top: 10px;
}
.m-copy-txt {
  padding-left: 140px;
}
</style>
